import { type OwnTableVariants, type TableOptions } from '../types'

export const getTableOptions = (variant: OwnTableVariants): TableOptions => {
  if (variant === 'default') {
    return {
      body: {
        dividers: true,
        spacing: 4,
      },
      header: {
        padding: { rightLeft: 16, topBottom: 16 },
      },
      row: {
        spacing: 8,
      },
    }
  } else if (variant === 'settings-slim') {
    return {
      body: {
        dividers: true,
        padding: { rightLeft: 0, topBottom: 0 },
      },
      header: {
        padding: { rightLeft: 8, topBottom: 8 },
        variant: 'title-small',
      },
      row: {
        padding: { rightLeft: 8, topBottom: 8 },
        radius: 8,
        spacing: 3,
      },
    }
  } else {
    return {
      body: {
        dividers: false,
        padding: { rightLeft: 8, topBottom: 8 },
      },
      header: {
        padding: { rightLeft: 16, topBottom: 16 },
      },
      row: {
        padding: { rightLeft: 8, topBottom: 8 },
        radius: 8,
        spacing: 4,
      },
    }
  }
}
